// src/components/AdImage/AdImage.jsx
import React from 'react';
import { getImageUrl } from '../../utils/imageUtils';
import './AdImage.css';

const AdImage = ({ image, variant = 'card', className = '', alt = "Oglasna slika" }) => {

    if (!image || !image.image_url) {
        return (
            <div className={`item-image-placeholder no-image ${className}`}>
                <div className="placeholder-content-wrapper">
                    <span>Ni slike</span>
                </div>
            </div>
        );
    }

    const { image_url, processing_status } = image;

    if (processing_status === 'failed') {
        return (
            <div className={`item-image-placeholder error ${className}`}>
                <div className="placeholder-content-wrapper">
                    <span title="Napaka pri obdelavi slike">⚠️</span>
                </div>
            </div>
        );
    }

    if (processing_status === 'processing') {
        return (
            <div className={`item-image-placeholder loading ${className}`}>
                {/* === TUKAJ JE SPREMEMBA === */}
                {/* Ta wrapper div bo poskrbel za centriranje */}
                <div className="placeholder-content-wrapper">
                    {/* Spinnerju pustimo, da se prosto vrti */}
                    <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            </div>
        );
    }
    
    // ... ostala koda ostane ista ...
    const mainSrc = getImageUrl(image_url, variant);
    const blurSrc = getImageUrl(image_url, 'blur');

    return (
        <div
            className={`item-image-container ${className}`}
            style={{ backgroundImage: `url(${blurSrc})` }}
        >
            <img
                src={mainSrc}
                alt={alt}
                loading="lazy"
                className="item-image-main"
            />
        </div>
    );
};

export default AdImage;